import { Button, FormControl, FormHelperText, Grid2, InputAdornment, OutlinedInput, Paper, TextField, Typography } from '@mui/material';
import './signup.css';
import signupImg from '../../assets/images/signup.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import PasswordIcon from '@mui/icons-material/Password';
import userIcon from '../../assets/icons/userIcon.png';
import passwordIcon from '../../assets/icons/Password.png';

const Signup = () => {
    // State to capture email and password
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Function to handle login
    const handleLogin = async (event) => {
        event.preventDefault();    //Prevents the form from refreshing the page
        try {
            const response = await fetch('https://dev-panel-backend.mobilityinfotech.com/admin-panel/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            });
            const data = await response.json();

            if (response.ok) {
                console.log('Login successful:', data.data.token);
                localStorage.setItem('token', data.data.token);
                localStorage.setItem('cities', JSON.stringify(data.data.client_cities));
                localStorage.setItem('cityId', data.data.city_id);
                localStorage.setItem('clientId', data.data.client_id);
                localStorage.setItem('clientRoleTabs', JSON.stringify(data.data.client_tabs));
                // var tkn = localStorage.getItem('token');
                // console.log('token = ', tkn)
                navigate("/mainDashboard");
            } else {
                setError(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    };

    return(
        <Paper elevation={3} style={{height:'97vh', width:'88vw', alignItems: 'center', justifyContent: 'center', margin: 'auto', borderRadius:'24px' }}>
            <Grid2 container spacing={2}  style={{margin:'2%', marginTop: '1%'}}>

                <Grid2 item size={{ xs: 12, md: 6, lg:6, xl:6 }} style={{marginTop:'2%'}}>
                    <img src={signupImg} alt="signup img" width="100%" height="82%" />
                </Grid2>

                <Grid2 item size={{ xs: 12, md: 5, lg:5, xl:5 }} style={{margin:'2%', marginTop:'10%'}} >
                    <Typography variant="h4" style={{fontWeight:700, fontSize:'32px'}}>Login</Typography>
                    <Typography style={{color:'#83888E', fontSize:'16px'}}>Please Enter Your Email & Password</Typography>

                    <form onSubmit={handleLogin}>
                        <Grid2 style={{marginTop:'20px'}}>
                            <Typography >Email</Typography>
                            {/* <TextField style={{marginTop:'2%'}} id="outlined-basic" label="Enter your Email" variant="outlined" fullWidth 
                            value={email} onChange={(e) => setEmail(e.target.value)} /> */}
                            <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth>
                                <OutlinedInput value={email} onChange={(e) => setEmail(e.target.value)}
                                    id="outlined-adornment-weight"
                                    startAdornment={<InputAdornment position="start"><img src={userIcon} alt="signup img" width="100%" height="82%" /></InputAdornment>}
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                    'aria-label': 'weight',
                                    placeholder: 'Enter your email',
                                    }}
                                />
                            </FormControl>
                        </Grid2>

                        <Grid2 style={{marginTop:'20px'}}>
                            <Typography>Password</Typography>
                            {/* <TextField style={{marginTop:'2%'}} id="outlined-basic" label="Enter your Password" variant="outlined" fullWidth
                            type="password" value={password} onChange={(e) => setPassword(e.target.value)} /> */}
                            <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth>
                                <OutlinedInput type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                                    id="outlined-adornment-weight"
                                    startAdornment={<InputAdornment position="start"><img src={passwordIcon} alt="signup img" width="100%" height="82%" /></InputAdornment>}
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                    'aria-label': 'password',
                                    placeholder: 'Enter your Password',
                                    }}
                                />
                            </FormControl>
                        </Grid2>

                        {error && (
                            <Typography style={{ color: 'red', marginTop: '12px' }}>{error}</Typography>
                        )}
                        
                        <Grid2 style={{float: 'right', marginTop:'12px'}}>
                            <Typography style={{color:'#0065FF', fontSize:'14px'}}>Forgot Password?</Typography>
                        </Grid2>
                        <Grid2 style={{marginTop:'10%'}}>
                            <Button type="submit" variant="contained" color="primary" fullWidth style={{padding:'3%'}} onClick={handleLogin}>
                                Login
                            </Button>
                        </Grid2>
                    </form>
                </Grid2>

            </Grid2>
        </Paper>
        
    );
};

export default Signup;